export default __webpack_public_path__ + "static/media/arrow.b30e8c1c.svg";